// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1k4IX","requiredAsterisk":"Info_requiredAsterisk__nPMop"};